(function () {
  function typesOf(card) {
    return (card.getAttribute('data-ttp-types') || '').split('|').filter(Boolean);
  }

  function shuffle(panel) {
    var grid = panel.querySelector('.ttp-grid');
    var pool = panel.querySelector('template.ttp-pool');
    var limit = parseInt(panel.getAttribute('data-ttp-shuffle'), 10);
    if (!grid || !pool || !limit) return;

    var cards = Array.prototype.slice.call(grid.children)
      .concat(Array.prototype.slice.call(pool.content.children));

    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = cards[i];
      cards[i] = cards[j];
      cards[j] = swap;
    }

    var used = {};
    var picked = [];
    for (var k = 0; k < cards.length && picked.length < limit; k++) {
      var types = typesOf(cards[k]);
      if (types.some(function (type) { return used[type]; })) continue;
      types.forEach(function (type) { used[type] = true; });
      picked.push(cards[k]);
    }

    grid.replaceChildren.apply(grid, picked);
    pool.remove();
  }

  // Native overflow covers touch, trackpad and wheel, but not mouse drag.
  function enableDrag(scroller) {
    if (scroller.dataset.ttpDrag) return;
    scroller.dataset.ttpDrag = 'true';

    var down = false, startX = 0, startLeft = 0, moved = false;

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
    });

    scroller.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      scroller.scrollLeft = startLeft - dx;
    });

    function endDrag() {
      if (!down) return;
      down = false;

      var left = scroller.scrollLeft;
      var origin = scroller.getBoundingClientRect().left;
      var target = left;
      var best = Infinity;
      Array.prototype.forEach.call(scroller.querySelectorAll('.ttp-panel'), function (panel) {
        var offset = panel.getBoundingClientRect().left - origin + left;
        if (Math.abs(offset - left) < best) {
          best = Math.abs(offset - left);
          target = offset;
        }
      });

      scroller.classList.remove('is-dragging');
      scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('pointerleave', endDrag);

    scroller.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // Suppress the click that ends a drag so it doesn't open a product page.
    scroller.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  }

  function initAll(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-ttp-shuffle]'), shuffle);
    Array.prototype.forEach.call(root.querySelectorAll('.ttp-scroller'), enableDrag);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
